// src/components/arrivals/TimeCell.jsx

import React from 'react'
import { formatIsoTime } from '@core/domain/time'
import { getArrivalStatus } from '@core/domain/arrivals'
import { formatHeadwayMinutes } from '@core/domain/format'
import { arrivalPresentation } from '@core/config/arrivalPresentation'

export default function TimeCell({
  schedTime,
  liveIso,
  headway,
  headwayColor,
  headwayBg,
  showSchedule,
  showLive,
  showHeadway,
  isFuture = false,
  statusColor,
  statusBg,
}) {
  const liveFormatted = liveIso ? formatIsoTime(liveIso) : null
  const status = liveFormatted ? getArrivalStatus(schedTime, liveFormatted) : null

  // Use explicit statusColor/statusBg if provided, else compute from status
  const liveColor = statusColor ?? status?.color ?? 'var(--text-secondary)'
  const liveBg = statusBg ?? (isFuture ? 'transparent' : status?.bgColor ?? 'transparent')

  const headwayDisplay = formatHeadwayMinutes(headway)

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      fontSize: 10,
      fontFamily: "'JetBrains Mono'",
      whiteSpace: 'nowrap',
    }}>
      {showSchedule && schedTime && (
        <span style={{ color: 'var(--text-muted)', fontSize: 10 }}>
          {schedTime}
        </span>
      )}

      {showLive && liveFormatted && (
        <span style={{
          fontWeight: arrivalPresentation.timeCell.liveFontWeight,
          color: liveColor,
          background: liveBg,
          padding: '1px 5px',
          borderRadius: 4,
          fontSize: 10,
        }}>
          {liveFormatted}
        </span>
      )}

      {showHeadway && headwayDisplay !== null && (
        <span style={{
          fontWeight: arrivalPresentation.timeCell.headwayFontWeight,
          color: headwayColor || 'var(--text-secondary)',
          background: headwayBg || 'transparent',
          padding: '1px 4px',
          borderRadius: 4,
          fontSize: 10,
        }}>
          {headwayDisplay}
        </span>
      )}
    </div>
  )
}